export default [
  {
    path: '/wardens', name: 'wardens', component: () => import('@/views/wardens/Index.vue'),
    meta: { resource: 'Warden', action: 'read', pageTitle: 'Warden Management', breadcrumb: [{ text: 'Warden Management', active: true }] },
  },
  {
    path: '/pos-users',
    name: 'pos-users',
    component: () => import('@/views/pos-users/Index.vue'),
    meta: {
      resource: 'User',
      action: 'read',
      pageTitle: 'POS Users',
      breadcrumb: [{ text: 'POS Users', active: true }],
    },
  },
  //COUNCIL PROFILE
  {
    path: '/users',
    name: 'user',
    component: () => import('@/views/user/Index.vue'),
    meta: {
      resource: 'User',
      action: 'read',
      pageTitle: 'User Management',
      breadcrumb: [
        {
          text: 'User Management',
          active: true
        }
      ],
    },
  },
  {
    path: '/users/edit/:id',
    name: 'users-edit',
    component: () => import('@/views/user/users-edit/UsersEdit.vue'),
    meta: {
      resource: 'User',
      action: 'update',
      pageTitle: 'User Edit',
      breadcrumb: [
        {
          text: 'User',
          to: '/users'
        },
        {
          text: 'Edit',
          active: true
        }
      ],
    },
  }
]
